import './Myorders.css'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { api } from '../services/api'
import { useUser } from '../context/UserContext'

const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`
const asList = (r) => (Array.isArray(r) ? r : Array.isArray(r?.data) ? r.data : Array.isArray(r?.items) ? r.items : [])
const itemsOf = (o) => {
  let l = o.items
  if (typeof l === 'string') { try { l = JSON.parse(l) } catch { l = [] } }
  return Array.isArray(l) ? l : []
}
const STEPS = ['New', 'Packed', 'Shipped', 'Delivered']

export default function MyOrders() {
  const [orders, setOrders] = useState(null)
  const [error, setError] = useState('')
  const { user, openAuth } = useUser()
  const { state } = useLocation()
  const justPlaced = state?.orderNo // pass { orderNo } via navigate('/orders', { state: { orderNo } }) after payment succeeds

  useEffect(() => {
    if (!user) { setOrders([]); return }
    let active = true
    const load = () => api.myOrders()
      .then((r) => {
        if (!active) return
        const l = asList(r)
        setOrders([...l].sort((a, b) => String(b.created_at ?? '').localeCompare(String(a.created_at ?? '')) || Number(b.id) - Number(a.id)))
        setError('')
      })
      .catch((e) => { if (active) { setError(e.message || 'Could not load your orders.'); setOrders((o) => o || []) } })
    load()
    const t = setInterval(load, 30000) // status updates from the admin show up by themselves
    return () => { active = false; clearInterval(t) }
  }, [user])

  if (!user) {
    return (
      <main className="myo">
        <h1>My orders</h1>
        <p>Please sign in to see the orders you have booked.</p>
        <button className="btn btn--cobalt" onClick={() => openAuth('login')}>Sign in</button>
      </main>
    )
  }

  return (
    <main className="myo">
      {justPlaced && (
        <div className="myo__ok" role="status">
          <span className="myo__tick" aria-hidden="true">✓</span>
          <div>
            <strong>Order confirmed</strong>
            <p>Thank you! Your order #{justPlaced} is placed. We will update you as it ships.</p>
          </div>
        </div>
      )}

      <h1>My orders</h1>
      {error && <p className="myo__err" role="alert">{error}</p>}
      {orders === null && <p>Loading…</p>}
      {orders && orders.length === 0 && !error && (
        <p>You have no orders yet. <Link to="/shop">Start shopping</Link></p>
      )}

      <ul className="myo__list">
        {(orders || []).map((o) => {
          const status = o.status || 'New'
          const step = STEPS.indexOf(status)
          const date = o.created_at ? new Date(o.created_at) : null
          return (
            <li key={o.id} className={`myo__card${String(o.order_no || o.id) === String(justPlaced) ? ' is-new' : ''}`}>
              <div className="myo__head">
                <strong>Order #{o.order_no || o.id}</strong>
                <span>{date && !isNaN(date) ? date.toLocaleDateString('en-IN', { dateStyle: 'medium' }) : ''}</span>
              </div>

              {status === 'Cancelled'
                ? <p className="myo__cancel">This order was cancelled.</p>
                : (
                  <ol className="myo__track" aria-label={`Order status: ${status}`}>
                    {STEPS.map((s, i) => <li key={s} className={i <= step ? 'is-on' : ''}>{s}</li>)}
                  </ol>
                )}

              <ul className="myo__items">
                {itemsOf(o).map((i, k) => <li key={k}>{i.qty} × {i.name} <span>{inr(i.price)}</span></li>)}
              </ul>
              <div className="myo__foot">
                <span>{[o.address, o.city, o.pincode].filter(Boolean).join(', ') || 'Pick up at the store'}</span>
                <strong>{inr(o.total ?? o.amount)}</strong>
              </div>
            </li>
          )
        })}
      </ul>
    </main>
  )
}